<div class="card shadow">
  <div class="card-body">
    <div class="list-group mt-2">
      <div class="list-group-item p-2 bg-light">
        <div class="row g-2">
          <div class="col-md-3"><label class="fw-bold">Jurisdiction</label></div>
          <div class="col-md-3"><label class="fw-bold">Product</label></div>
          <div class="col-md-3"><label class="fw-bold">Game Type</label></div>
          <div class="col-md-1"><label class="fw-bold">Qty</label></div>
          <div class="col-md-2"></div>
        </div>
      </div>
      @for (item of items; track item; let i = $index) {
        <div class="list-group-item p-2"
          [class.item-frozen]="isFrozen(i)"
          [class.item-change-of-scope]="!isFrozen(i) && isChangeOfScope(i)"
          >
          @if (isFrozen(i)) {
            <div class="frozen-banner d-flex align-items-center gap-2 mb-2 px-2 py-1">
              <i class="bi bi-lock-fill"></i>
              <span class="fw-semibold">Change of Scope — this item is frozen and cannot be modified.</span>
            </div>
          }
          @if (!isFrozen(i) && isChangeOfScope(i)) {
            <div class="change-of-scope-banner d-flex align-items-center gap-2 mb-2 px-2 py-1">
              <i class="bi bi-arrow-repeat"></i>
              <span class="fw-semibold">Change of Scope</span>
            </div>
          }
          <div class="row g-2">
            <div class="col-md-3">
              <input-field [inputFormControl]="getFormControl(itemsForms[i], 'jurisdiction')"
                type="text" [readonly]="true" />
            </div>
            <div class="col-md-3">
              <input-field [inputFormControl]="getFormControl(itemsForms[i], 'product')"
                type="text" [readonly]="true" />
            </div>
            <div class="col-md-3">
              <input-field [inputFormControl]="getFormControl(itemsForms[i], 'gameType')"
                type="text" [readonly]="true" />
            </div>
            <div class="col-md-1">
              <input-field [inputFormControl]="getFormControl(itemsForms[i], 'qty')"
                type="number" [readonly]="readonly || isFrozen(i)" />
            </div>
            <div class="col-md-2">
              <button class="btn btn-primary w-100"
                [disabled]="isCreateWorkingListDisabled(i)"
                (click)="createWorkingList(i)">
                Create Working List
              </button>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</div>